import ErrorType from '../Shared/Constants/ErrorType';
import IConfig   from '../State/Stores/Config/Interfaces/IConfig';

import IMedia from './Interfaces/IMedia';
import Player from './Player';

/**
 * A facade between the `Player` instance and consumer, ensuring that
 * only the necessary methods and properties are exposed to the consumer.
 */

class PlayerFacade {
    public configure: (options: IConfig) => void;
    public destroy: () => Promise<void>;
    public error: (errorType: ErrorType) => void;
    public load: (media: IMedia) => void;
    public unload: () => void;
    public play: () => void;
    public pause: () => void;
    public seek: (time: number) => void;
    public volume: (level: number) => void;
    public fadeInVolume: () => void;
    public fadeOutVolume: () => void;
    public showControls: () => void;
    public hideControls: () => void;
    public enterFullscreen: () => void;
    public exitFullscreen: () => void;

    public addEventListener: EventTarget['addEventListener'];
    public removeEventListener: EventTarget['removeEventListener'];

    constructor(wrapper: HTMLElement, options: IConfig) {
        const player = new Player(wrapper, options);

        this.configure = player.configure.bind(player);
        this.destroy = player.destroy.bind(player);
        this.error = player.error.bind(player);
        this.load = player.load.bind(player);
        this.unload = player.unload.bind(player);
        this.play = player.play.bind(player);
        this.pause = player.pause.bind(player);
        this.seek = player.seek.bind(player);
        this.volume = player.volume.bind(player);
        this.fadeInVolume = player.fadeInVolume.bind(player);
        this.fadeOutVolume = player.fadeOutVolume.bind(player);
        this.showControls = player.showControls.bind(player);
        this.hideControls = player.hideControls.bind(player);
        this.enterFullscreen = player.enterFullscreen.bind(player);
        this.exitFullscreen = player.exitFullscreen.bind(player);

        this.addEventListener = player.addEventListener.bind(player);
        this.removeEventListener = player.removeEventListener.bind(player);

        Object.defineProperties(this, {
            state: {
                get: () => player.state
            },
            state$: {
                get: () => player.state$
            },
            interactions$: {
                get: () => player.interactions$
            },
            errors$: {
                get: () => player.errors$
            }
        });
    }
}

export default PlayerFacade;